const t = {
  name: "InternalAuditTeam",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.0002 14.4142L15.4144 9.00003L14.0002 7.58582L10.0002 11.5858L8.00015 9.58582L6.58594 11L10.0002 14.4142Z" fill="currentColor"/>
<path d="M2 11C2 6.02772 6.02772 2 11 2C15.9723 2 20 6.02772 20 11C20 13.1257 19.2639 15.0787 18.0326 16.6182L23.4144 22L22.0002 23.4142L16.6184 18.0325C15.0788 19.2639 13.1257 20 11 20C6.02772 20 2 15.9723 2 11ZM11 4C7.13228 4 4 7.13228 4 11C4 14.8677 7.13228 18 11 18C14.8677 18 18 14.8677 18 11C18 7.13228 14.8677 4 11 4Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as InternalAuditTeam
};
